import React from 'react';
import { Link } from 'react-router-dom';
import { MetaHead } from '../components/MetaHead';
import { COMPANY_INFO } from '../data/scrapedData';

export function NotFoundPage() {
  return (
    <>
      <MetaHead title="Siden blev ikke fundet (404) - Den Selvejende Institution Midtgaarden" description="Den søgte side kunne ikke findes." />

      <section className="min-h-[60vh] py-20 bg-[#F8FAFC] flex items-center justify-center">
        <div className="max-w-xl mx-auto px-4 text-center space-y-6">
          
          <div className="w-16 h-16 rounded-full bg-[#3885B8]/10 text-[#3885B8] flex items-center justify-center text-2xl font-bold mx-auto">
            404
          </div>

          <h1 className="text-3xl font-extrabold text-[#1C1C1E] tracking-tight">
            Siden blev ikke fundet
          </h1>

          <p className="text-sm sm:text-base text-[#1C1C1E]/75 leading-relaxed">
            Siden du leder efter findes desværre ikke eller er flyttet. Du kan benytte knapperne herunder til at navigere videre på hjemmesiden eller kontakte os direkte.
          </p>

          <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/"
              className="w-full sm:w-auto bg-[#1C1C1E] hover:bg-[#000000] text-white px-6 py-3 rounded-xl font-semibold text-sm transition-colors text-center"
            >
              Gå til Forside
            </Link>

            <Link
              to="/behandling"
              className="w-full sm:w-auto bg-white border border-[#1C1C1E]/20 text-[#1C1C1E] hover:bg-[#1C1C1E]/5 px-6 py-3 rounded-xl font-semibold text-sm transition-colors text-center"
            >
              Se Behandling
            </Link>
          </div>

          <div className="pt-6 border-t border-[#1C1C1E]/10 flex flex-col sm:flex-row items-center justify-center gap-4 text-xs font-medium">
            <a href={COMPANY_INFO.phoneTel} className="text-[#3885B8] hover:underline flex items-center gap-1.5 whitespace-nowrap">
              <i className="fa-solid fa-phone" aria-hidden="true" />
              <span>Ring 75 17 20 80</span>
            </a>

            <a href={COMPANY_INFO.emailMailto} className="text-[#3885B8] hover:underline flex items-center gap-1.5 whitespace-nowrap">
              <i className="fa-solid fa-envelope" aria-hidden="true" />
              <span>Skriv til os</span>
            </a>
          </div>

        </div>
      </section>
    </>
  );
}
